/*************************************************/
/* POPUP ALERT                                   */
/*************************************************/

export function popupAlert() {
    const DICTIONARY_API_URL = `/umbraco/api/DictionaryApi/GetDictionaryValue?culture=${currentUmbracoCulture}`;
    const externalLinks = document.querySelectorAll('.language-selector__list-item--external');
    let dictionary = {};

    const init = async () => {
        try {
            const response = await fetch(DICTIONARY_API_URL);
            if (!response.ok) {
                console.error(`Error fetching dictionary: ${response.status} ${response.statusText}`);
                dictionary = {
                    "PopUpAlert.Text": "⚠️ You are about to leave the current website.",
                    "PopUpAlert.Continue": "Continue",
                    "PopUpAlert.Stay": "Stay Here"
                };
            } else {
                dictionary = await response.json();
            }
        } catch (error) {
            console.error('Network error during dictionary fetch:', error);
            dictionary = {
                "PopUpAlert.Text": "⚠️ You are about to leave the current website.",
                "PopUpAlert.Continue": "Continue",
                "PopUpAlert.Stay": "Stay Here"
            };
        }
        
        function createCustomAlert() {
            const alertBackdrop = document.createElement('div');
            alertBackdrop.id = 'customAlertBackdrop';
            alertBackdrop.classList.add('custom-alert-backdrop');

            const alertBox = document.createElement('div');
            alertBox.classList.add('custom-alert-box');

            const message = document.createElement('p');
            message.innerHTML = dictionary['PopUpAlert.Text'];
            alertBox.appendChild(message);

            const buttonContainer = document.createElement('div');
            buttonContainer.classList.add('alert-button-container');
 
            const continueButton = document.createElement('button');
            continueButton.textContent = dictionary['PopUpAlert.Continue'];
            continueButton.classList.add('alert-button', 'continue-button');
            buttonContainer.appendChild(continueButton);
            
            const cancelButton = document.createElement('button');
            cancelButton.textContent = dictionary['PopUpAlert.Stay'];
            cancelButton.classList.add('alert-button', 'cancel-button');
            buttonContainer.appendChild(cancelButton);

            alertBox.appendChild(buttonContainer);
            alertBackdrop.appendChild(alertBox);

            document.body.appendChild(alertBackdrop);

            return { alertBackdrop, continueButton, cancelButton };
        }

        let targetUrl = '';

        externalLinks.forEach(link => {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                targetUrl = this.href;

                showAlert();
            });
        });

        let currentAlert = null;
        function showAlert() {
            if (!currentAlert) {
                currentAlert = createCustomAlert();
            }

            const { alertBackdrop, continueButton, cancelButton } = currentAlert;

            const closeAlert = () => {
                 if (currentAlert) {
                     currentAlert.alertBackdrop.style.display = 'none';
                 }
            };
            
            continueButton.onclick = () => {
                closeAlert();
                window.open(targetUrl, '_blank');
            };

            cancelButton.onclick = () => {
                closeAlert();
            };

            alertBackdrop.onclick = function (event) {
                if (event.target === alertBackdrop) {
                    closeAlert();
                }
            };

            alertBackdrop.style.display = 'flex';
        }  
    };

    init();
}